import { Create, useForm } from "@refinedev/antd";
import { HttpError } from "@refinedev/core";
import { Form, Input, InputNumber, Select } from "antd";
import { ImageUpload } from "../../components/ImageUpload";

export function BannerCreate() {
  const { formProps, saveButtonProps, formLoading } = useForm<any, HttpError, any>({
    resource: "banner",
    successNotification: (data) => {
      return {
        message: data?.data.message,
        type: "success",
      };
    },
    action: "create",
  });

  return (
    <Create saveButtonProps={saveButtonProps} isLoading={formLoading} title="Create banner">
      <Form {...formProps} layout="vertical">
        <Form.Item label="Title" name={["title"]} rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item label="Description" name={["description"]}>
          <Input.TextArea />
        </Form.Item>

        <Form.Item label="Status" name={["status"]} initialValue="ACTIVE">
          <Select>
            <Select.Option value="ACTIVE">ACTIVE</Select.Option>
            <Select.Option value="INACTIVE">INACTIVE</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item label="Priority" name={["priority"]} initialValue={0}>
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item label="Link" name={["link"]}>
          <Input placeholder="https://... or /deeplink" />
        </Form.Item>

        <Form.Item label="Image" name="mediaID">
          <ImageUpload uploadType="BANNER" />
        </Form.Item>
      </Form>
    </Create>
  );
}


